module.exports = __webpack_public_path__ + "img/48.5b2c8173.jpg";